export default {
  toastErrorTitle: {
    id: 'error_toast_intercom_not_available_title',
    defaultMessage: 'Hmm, we’re glitching',
  },
  toastErrorContent: {
    id: 'error_toast_intercom_not_available_content',
    defaultMessage: 'Something went wrong on our end. Please try again.',
  },
}
